import {QueryClient} from '@tanstack/react-query';
import isAuthError from '../api/isAuthError';
import {isSessionExpiredError} from '../api/authErrors';

// Shared at module scope so non-component code (e.g. AuthContext recovery) can
// invalidate queries after a successful session recovery — stale "Unauthorized."
// panels then refetch and clear without a full page reload.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Never retry definitive auth failures — a server 401, or a
            // SessionExpiredError from the fetch layer, is the signal for the
            // session-expired banner, not something to hammer. Transient errors
            // (incl. AuthUnavailableError) still get a couple of backed-off retries.
            retry: (failureCount, error) =>
                isAuthError(error) || isSessionExpiredError(error)
                    ? false
                    : failureCount < 2,
            retryDelay: attempt => Math.min(1000 * 2 ** attempt, 8000)
        },
        mutations: {
            retry: 0
        }
    }
});

export default queryClient;
